export const defaultStyle = {
  bannerContent: "relative lg:h-[450px] overflow-hidden bannerContent ",
  gradBox: "lg:h-[450px] h-[324px] overflow-hidden absolute w-1/2 lg:bg-gradBgLetToRigth z-[1]",
  imageResponsive: "image  relative lg:static top-[82px] md:top-[70px] lg:top-[0] scale-[2.2] md:scale-[1.45] lg:scale-[1] lg:left-auto md:left-[-22%] left-[-52%] md:h-[768px] md:w-[575px]",
  txtcontent: "philyDiffTxt lg:right-[58.5vw] lg:mt-10 md:mt-[136px] mt-[165px] lg:bg-transparent bg-darkBlue lg:absolute lg:text-white  lg:top-[23%]  my-0 mx-auto px-0 lg:py-8 py-30 relative lg:w-[352px] lg:text-left text-white w-full text-center z-[2]",
  txtHead: "text-[35px] mb-7 leading-[50.75px]",
  txtDesc: "text-xl text-white lg:px-[0] lg:mt-auto leading-30 lg:w-full w-[348px] md:w-[352px] mx-auto",
  textLink: " ",
  heroLink: "px-10 text-sm tracking-wide text-darkBlue font-medium before:content-['/'] before:pr-5",
}

export const contentInRight = {
  bannerContent: "relative",
  image: "image w-full",
  txtcontent: "lg:absolute lg:text-white lg:right-[15%] lg:w-[28%] lg:bg-transparent lg:top-[23%] clear-both my-0 mx-auto px-0 py-8 relative lg:text-left text-white w-full text-center",
  txtHead: "text-4xl mb-1",
  txtDesc: "text-xl",
  textLink: " ",
  imageResponsive: "image",
}

export const RECIPE_DETAIL_HERO = {
  bannerContent: "relative lg:h-[530px] md:h-[350px] h-[425px] top-0 overflow-hidden ",
  imageResponsive: "image w-full  relative lg::top-[78px] lg:top-[-17%] md:top-[-52px] md:scale-[1.2] lg:scale-[1] lg:left-auto",
  txtcontent: "w-full lg:bg-transparent absolute lg:text-white lg:max-w-full top-[40%] lg:top-[36.5%] clear-both my-0 mx-auto px-0 lg:py-8 pt-30  lg:text-left text-white w-full text-center z-[2]",
  txtHead: "lg:w-[900px] lg:text-[50px] text-[35px] lg:leading-[55px] leading-[38px] mb-1 font-Bold text-center heroShadow tracking-[1px] mx-auto",
  txtDesc: "text-xl text-white lg:pt-15 px-15 lg:px-[0] mt-20 lg:mt-auto",
  textLink: " ",
  heroLink: "buttonEffect2 watchVideo",
  backBtn: "w-full lg:bg-transparent absolute text-[15px] lg:text-white lg:max-w-full lg:top-[4%] top-0 clear-both my-0 mx-auto px-0 lg:py-8 py-30 lg:pt-0 text-white w-full text-center z-[2] heroShadow tracking-[0] backButton",
}

export const TEXT_BANNER = {
  heading: "text-3xl text-white text-center heroText mt-16 font-Light tracking-wide",
  bannerContent: "relative",
  image: "image w-full",
  txtcontent: "",
  txtHead: "text-3xl mb-1 text-white text-center absolute lg:top-[25%] md:top-[22%] top-[35%] left-[50%] translate-x-[-50%] translate-y-0 font-Light tracking-[1px] w-full leading-[37.5px]",
  txtDesc: "txtDesc text-[15px] max-w-full w-[750px] leading-[30px] my-0 mx-auto lg:mt-0 mt-30 text-center md:px-0 px-8 absolute lg:bottom-[-75%] md:bottom-[-50%] bottom-[-113%] text-darkBlue text-center left-[50%] translate-x-[-50%] translate-y-0 tracking-normal font-normal textBanner",
  textLink: "inline-block leading-7 relative text-white align-middle ",
  imgWrapper: "w-full flex justify-center",
  imgParent: "lg:relative lg:h-[428px] md:h-[500px] h-[300px]",
  imgBg: "bg-[#00329f] absolute top-0 left-0 w-full lg:h-full z-[-1] md:h-[85%] h-[115%]",
  imageResponsive: "w-[600px] m-w-full absolute lg:top-[41%] md:top-[35%] top-[59%]  left-[50%] translate-x-[-50%] translate-y-0",
  linkWrpr: "",
  backBtn: "lg:bg-transparent absolute text-[15px] lg:text-white left-[50%] translate-x-[-50%] translate-y-0 lg:top-[8%] md:top-[3%] top-0 my-0 mx-auto px-0 lg:py-8 py-30  text-white w-full text-center backButton"
}

export const ABOUT_US_BANNER = {
  ...defaultStyle,
  bannerContent: 'aboutusBanner relative lg:h-[575px] overflow-hidden bannerContent md:mb-[50px] mb-[30px]',
  gradBox: "gradBox",
  imageResponsive: "image w-full md:h-[575px] object-cover relative lg:m-auto ",

}

export const IMAGE_BANNER_NO_COVER = {
  ...ABOUT_US_BANNER,
  imageResponsive: "image w-auto object-contain relative lg:m-auto ",
  bannerContent: 'aboutusBanner relative bannerContent md:mb-[50px] mb-[30px]',
}

export const BANNER_WITH_BUTTON = {
  ...defaultStyle,
  bannerContent: "relative h-[190px] md:h-[575px] bannerContent mb-[30px] lg:mb-[50px]",
  bannerForm: "hidden",
  gradBox: "lg:h-[450px] h-[324px] absolute w-1/2",
  imageResponsive: "image h-[152px] w-full md:h-[575px] object-cover relative lg:m-auto ",
  heroLinkWrapper: 'heroLinkWrapper absolute bottom-[0] md:bottom-[14%] flex w-full justify-center',
  heroLink: "text-[#fff] rounded-[40px] border-2 border-solid border-[#fff] bg-[#e18719] px-[45px] py-[20px] uppercase inline-block text-center text-[21px] leading-[21px] tracking-[0.53px] lg:tracking-[2.2px] font-bold hover:bg-[#fff] hover:text-[#000] hover-transition-all duration-500",
}

export const BANNER_WITH_FORM = {
  ...ABOUT_US_BANNER,
  bannerContent: "relative min-h-[160px] md:min-h-auto lg:h-[575px] overflow-hidden bannerContent mb-[30px] lg:mb-[50px]",
  bannerForm: "bannerForm absolute bottom-0 md:bottom-[61%] w-full h-full md:h-auto",
  gradBox: "hidden",
  imageResponsive: "image w-full md:h-[575px] object-cover relative lg:m-auto",
  txtcontent: "philyDiffTxt lg:right-[58.5vw] lg:mt-10 md:mt-[136px] mt-[165px] lg:bg-transparent bg-darkBlue lg:absolute lg:text-white  lg:top-[23%]  my-0 mx-auto px-0 lg:py-8 py-30 relative lg:w-[352px] lg:text-left text-white w-full text-center z-[2]",
  txtHead: "text-[35px] mb-7 leading-[50.75px]",
  txtDesc: "text-xl text-white lg:px-[0] lg:mt-auto leading-30 lg:w-full w-[348px] md:w-[352px] mx-auto",
  textLink: " ",
  heroLinkWrapper: 'heroLinkWrapper absolute bottom-0 md:bottom-[15%] w-full text-center',
  inputWrap: "inputWrap relative flex mt-[5px] justify-center",
  selectWrap: "selectWrap relative w-[60%] left-[20%] md:left-0 md:w-full md:flex md:mt-[5px] md:justify-center md:flex-row",
  heroLink: "text-[#fff] rounded-[40px] border-2 border-solid border-[#fff] bg-[#e18719] px-[45px] py-[20px] uppercase inline-block text-center text-[19px] lg:text-[21px] leading-[21px] tracking-[0.53px] lg:tracking-[2.2px] font-bold hover:bg-[#fff] hover:text-[#000] hover-transition-all duration-500",
  buttonWrapper: "buttonWrapper w-[25px] h-[25px] ml-[5px] md:w-[50px] md:h-[50px] md:ml-0",
}
export const BANNER_IMAGE_VIDEO = {
  ...BANNER_WITH_FORM,
  bannerContent: "relative lg:h-screen overflow-hidden bannerContent mt-[-8px]",
  bannerForm: "bannerForm absolute bottom-0 md:bottom-[61%] w-full top-[44px] md:top-[100px]",
  gradBox: "hidden",
  imageResponsive: "image w-full md:h-[575px] object-cover relative lg:m-auto",
  txtcontent: "philyDiffTxt lg:right-[58.5vw] lg:mt-10 md:mt-[136px] mt-[165px] lg:bg-transparent bg-darkBlue lg:absolute lg:text-white  lg:top-[23%]  my-0 mx-auto px-0 lg:py-8 py-30 relative lg:w-[352px] lg:text-left text-white w-full text-center z-[2]",
  txtHead: "text-[35px] mb-7 leading-[50.75px]",
  txtDesc: "text-xl text-white lg:px-[0] lg:mt-auto leading-30 lg:w-full w-[348px] md:w-[352px] mx-auto",
  textLink: " ",
  heroLinkWrapper: 'heroLinkWrapper absolute bottom-0 md:bottom-[15%] w-full text-center',
  inputWrap: "inputWrap relative flex mt-[5px] justify-center",
  selectWrap: "selectWrap relative w-[60%] left-[20%] md:left-0 md:w-full md:flex md:mt-[5px] md:justify-center md:flex-row",
  heroLink: "text-[#fff] rounded-[40px] border-2 border-solid border-[#fff] bg-[#e18719] px-[45px] py-[20px] uppercase inline-block text-center text-[19px] lg:text-[21px] leading-[21px] tracking-[0.53px] lg:tracking-[2.2px] font-bold hover:bg-[#fff] hover:text-[#000] hover-transition-all duration-500",
  buttonWrapper: "buttonWrapper w-[25px] h-[25px] ml-[5px] md:w-[50px] md:h-[50px] md:ml-0",
}

export const LEFT_TEXT_BANNER = { // used for the banner which have left text content
  ...TEXT_BANNER,
  bannerContent: "relative md:mt-[-8px]",
  foregroundImgWrapper:'foregroundImgWrapper max-[767px]:[&>img]:min-h-[205px] min-h-[205px] md:min-h-[631px] md:[&>img]:min-h-[631px]',
  txtcontent: "px-[35px] md:px-15 pt-[44px] md:absolute md:top-0 max-[767px]:min-h-[89px] w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  txtHead: "text-left text-[10px] text-[#4f2170] tracking-[2px] mb-[30px] font-bold uppercase md:text-[21px] tracking-[4.2px] md:text-white md:leading-[31px]",
  txtDesc: "txtDesc max-w-full text-left px-[35px] md:px-15 static md:absolute md:top-[90px] w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto min-h-[183px] md:min-h-full",
  imgParent: "lg:relative lg:h-[428px] md:h-[500px] h-[300px] hidden",
  imageResponsive: "image w-full md:h-[575px] object-cover relative lg:m-auto",
  heroLinkWrapper: "text-center pb-[70px] px-[35px] md:px-15 max-[767px]:w-[362px] md:text-left static md:absolute md:top-[420px] w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto min-h-[135px]",
  heroLink: "text-[#4f2170] text-[21px] leading-[21px] tracking-[2.2px] text-center uppercase rounded-[40px] border-2 border-solid border-[#4f2170] inline-block bg-transparent font-[700] py-20 px-[45px] hover:text-[#ffffff] hover:bg-[#724D8D] hover:border-[#724D8D] md:text-white md:border-white md:hover:text-black md:hover:bg-white md:hover:border-white max-[767px]:min-w-[268px] min-h-[65px] md:min-h-full font-Bold max-w-[292px] md:max-w-full",
  bannerTextWrapWidth:"bannerTextWrapWidth w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:absolute md:top-[8%] md:right-0 md:left-0 min-h-[407px] md:min-h-full",
}


export const SNACKING_MADE_RIGHT_BANNER = {
  bannerContent: "relative overflow-hidden ",
  imageResponsive: "image w-full  relative",
  bannerTextWrapWidth: "w-full bg-black bg-opacity-50 absolute top-[40%] py-[30px] px-[20px] lg:px-0 z-[2]",
  txtcontent: "mb-24",
  txtHead: "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-white text-center mx-auto",
  txtDesc: "text-[26px] leading-[31.2px] text-white text-center font-BwSurco font-[500]",
  textLink: " ",
  heroLink: "",
  backBtn: "",
}

export const BUSINESS_INDIA_BANNER = {
  bannerContent: "relative overflow-hidden ",
  imageResponsive: "image w-full  relative",
  bannerTextWrapWidth: "business-india-banner w-full h-full absolute top-0 flex flex-col justify-center px-[20px] lg:px-0 z-[2]",
  txtcontent: "mb-24",
  txtHead: "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-white text-center mx-auto",
  txtDesc: "text-[26px] leading-[31.2px] text-white text-center font-BwSurco font-[500]",
  textLink: " ",
  heroLink: "",
  backBtn: "",
}

export const SNACKING_MADE_RIGHT_LAST_BANNER = {
  bannerContent: "relative overflow-hidden ",
  imageResponsive: "image w-full  relative",
  bannerTextWrapWidth: "w-full h-full absolute top-0 flex flex-col justify-center px-[20px] lg:px-0 z-[2]",
  txtcontent: "mb-24",
  txtHead: "text-[32px] leading-[38.4px] font-bold text-white text-center mx-auto mb-[32px]",
  txtDesc: "",
  textLink: "",
  heroLinkWrapper: "text-center",
  heroLink: "bg-Bisque text-[18px] leading-[27px] font-BwSurcoBold py-[16px] px-[32px] inline-block mx-auto rounded-full uppercase hover:bg-[#D4B7EC] transition delay-100 duration-300 ease-in-out",
  backBtn: "",
}

export const SNACKING_MADE_RIGHT_TEXT = {
  bannerContent: "bg-[#FFD8AA] py-60 snacking-last relative",
  imageResponsive: "image w-full  relative",
  bannerTextWrapWidth: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  txtcontent: "mb-24",
  txtHead: "font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-purple text-center mb-[24px]",
  txtDesc: "font-BwSurco text-[26px] leading-[31.2px] text-purple tracking-normal text-center",
  textLink: "",
  heroLinkWrapper: "btnContainer absolute bottom-[-122%] lg:bottom-80 right-20 lg:right-32 z-10",
  heroLink: "text-[18px] leading-[27px] font-BwSurcoBold inline-block mx-auto rounded-full uppercase",
  backBtn: "btnContainer absolute bottom-100 lg:bottom-80 right-12 lg:right-32",
}
